import React from "react";

const ConfigContext = React.createContext({
  phoneLandlineLabelShort: "02 3540 9181",
  phoneLandlineLabel: "(+39) 02 3540 9181",
  phoneLandlineValue: "+390235409181",
  whatsappLabel: "(+39) 389 314 2744",
  whatsappValue: "3893142744",
  supportEmail: "support@gromia.com",
});

export const useLayoutConfig = () => React.useContext(ConfigContext);
